__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@iwt-core-web/branded-shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aviv-csnt/react", "3.1.0", () => (() => (__webpack_require__(3261))), 1);
			register("@aviv-dxp/react-thor", "2.25.9", () => (() => (__webpack_require__(7634))), 1);
			register("@aviv-trak/feature-flagging", "1.5.1", () => (() => (__webpack_require__(2070))), 1);
			register("@aviv-unified-frontend/runtime/authentication", "11.0.6", () => (() => (__webpack_require__(5301))), 1);
			register("@aviv-unified-frontend/runtime/brand", "11.0.6", () => (() => (__webpack_require__(6162))), 1);
			register("@aviv-unified-frontend/runtime/environment", "11.0.6", () => (() => (__webpack_require__(6210))), 1);
			register("@aviv-unified-frontend/runtime/fetcher", "11.0.6", () => (() => (__webpack_require__(9556))), 1);
			register("@aviv-unified-frontend/runtime/head", "11.0.6", () => (() => (__webpack_require__(9195))), 1);
			register("@aviv-unified-frontend/runtime/i18n", "11.0.6", () => (() => (__webpack_require__(8921))), 1);
			register("@aviv-unified-frontend/runtime/lifecycle", "11.0.6", () => (() => (__webpack_require__(2245))), 1);
			register("@aviv-unified-frontend/runtime/monitoring", "11.0.6", () => (() => (__webpack_require__(531))), 1);
			register("@aviv-unified-frontend/runtime/router", "11.0.6", () => (() => (__webpack_require__(7246))), 1);
			register("@aviv-web-core/tracking", "1.3.0", () => (() => (__webpack_require__(9812))), 1);
			register("@gemini/core", "3.7.0", () => (() => (__webpack_require__(1026))), 1);
			register("@iwt-core-web/consent-react", "1.0.1", () => (() => (__webpack_require__(4790))), 1);
			register("@iwt-core-web/design-system-core", "1.0.0", () => (() => (__webpack_require__(7277))), 1);
			register("@iwt-core-web/feature-flagging", "1.1.1", () => (() => (__webpack_require__(4332))), 1);
			register("@iwt-core-web/runtime/authentication", "1.1.0", () => (() => (__webpack_require__(1165))), 1);
			register("@iwt-core-web/runtime/brand", "1.1.0", () => (() => (__webpack_require__(7914))), 1);
			register("@iwt-core-web/runtime/environment", "1.1.0", () => (() => (__webpack_require__(9434))), 1);
			register("@iwt-core-web/runtime/fetcher", "1.1.0", () => (() => (__webpack_require__(604))), 1);
			register("@iwt-core-web/runtime/head", "1.1.0", () => (() => (__webpack_require__(9491))), 1);
			register("@iwt-core-web/runtime/i18n", "1.1.0", () => (() => (__webpack_require__(2577))), 1);
			register("@iwt-core-web/runtime/lifecycle", "1.1.0", () => (() => (__webpack_require__(8221))), 1);
			register("@iwt-core-web/runtime/monitoring", "1.1.0", () => (() => (__webpack_require__(4043))), 1);
			register("@iwt-core-web/runtime/router", "1.1.0", () => (() => (__webpack_require__(854))), 1);
			register("@iwt-core-web/tracking", "1.0.1", () => (() => (__webpack_require__(6253))), 1);
			register("@react-aria/focus", "3.22.0", () => (() => (__webpack_require__(5227))), 1);
			register("@react-aria/i18n", "3.13.0", () => (() => (__webpack_require__(7060))), 1);
			register("@react-aria/interactions", "3.28.0", () => (() => (__webpack_require__(6850))), 1);
			register("@react-aria/overlays", "3.32.0", () => (() => (__webpack_require__(7528))), 1);
			register("@react-aria/ssr", "3.10.0", () => (() => (__webpack_require__(9591))), 1);
			register("@react-aria/toast", "3.1.0", () => (() => (__webpack_require__(5813))), 1);
			register("@react-aria/utils", "3.34.0", () => (() => (__webpack_require__(2109))), 1);
			register("@react-stately/overlays", "3.7.0", () => (() => (__webpack_require__(3523))), 1);
			register("@react-stately/toast", "3.2.0", () => (() => (__webpack_require__(7577))), 1);
			register("react-dom/client", "19.2.7", () => (() => (__webpack_require__(7541))), 1);
			register("react-dom/server", "19.2.7", () => (() => (__webpack_require__(1967))), 1);
			register("react-dom", "19.2.7", () => (() => (__webpack_require__(7868))), 1);
			register("react/jsx-runtime", "19.2.7", () => (() => (__webpack_require__(9793))), 1);
			register("react", "19.2.7", () => (() => (__webpack_require__(405))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};